let map = {
    7: '圆通',
    15: '中通',
    8: '申通',
    30: '京东',
    12: '顺丰',
    17: 'EMS',
    9: '韵达',
    1021: '极兔',
    9997: '申通-重'
}

const options = [
    { label: '极兔', value: 1021 },
    { label: '圆通', value: 7 },
    { label: '中通', value: 15 },
    { label: '申通', value: 8 },
    { label: '顺丰', value: 12 },
    { label: '京东', value: 30 },
    { label: 'EMS', value: 17 },
    { label: '韵达', value: 9 },
    { label: '申通-重', value: 9997 },
    {label: '邮政电商标快', value: 1109}
]

const getCompany = (logisticsId) => {
    return map[logisticsId]
}

/**
 * @param onlyList 只要哪些物流公司
 * @param excludeList 排除哪些物流公司
 * @returns {*[]}
 */
const getCompanyOptions = (onlyList, excludeList) => {
    //返回新的实例，防止被修改
    const resOptions = []

    const list = options.filter(op => {
        let onlyFlag = true
        let excludeFlag = true
        if (onlyList && onlyList.length) {
            onlyFlag = onlyList.indexOf(op.value) > -1
        }
        if (excludeList && excludeList.length) {
            excludeFlag = excludeList.indexOf(op.value) === -1
        }
        return onlyFlag && excludeFlag
    })

    list.forEach(op => {
        let { label, value } = op
        resOptions.push({ label, value })
    })
    return resOptions
}

const getDefaultLogistics = () => {
    return 8
}

export default {
    getCompany,
    getCompanyOptions,
    getDefaultLogistics
}



// WEBPACK FOOTER //
// ./src/utils/logisticsUtils.js